<template>
  <OfficeLayout>
    <div>
      <TicketsNav/>
    </div>
    <transition name="router-anim">
      <router-view/>
    </transition>
  </OfficeLayout>
</template>

<script>
import OfficeLayout from "@/components/layouts/cabinet/OfficeLayout";
import TicketsNav from "@/components/cabinet/Tickets/TicketsNav";

export default {
  name: "TheTickets",
  components: {TicketsNav, OfficeLayout}
}
</script>